module.exports = {
    'Detail': require('./detail'),
    'EmbeddedEvents': require('./embedded-events')
};